export const isMobile = window.navigator.maxTouchPoints || 'ontouchstart' in document;
